import { render, staticRenderFns } from "./RegistrationConfirmationModal.vue?vue&type=template&id=f6c3882e&"
import script from "./RegistrationConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirmationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegistrationConfirmationModal.vue"
export default component.exports